// extracted by mini-css-extract-plugin
export default {"row":"sectionItem_row__0b-tI"};